module.exports = __webpack_public_path__ + "static/Lato-MediumItalic-96f828791c07f91c0aa986e603b3b4d3.ttf";